export const I18N_CONFIG = Object.freeze({
  DEFAULT_LANGUAGE: 'en',
  FALLBACK_LANGUAGE: 'en',
  NAMESPACE: 'translation'
} as const)

export const ROUTE_PARAM = Object.freeze({
  REFERRAL_CODE: ':referralCode',
  MAGIC_TOKEN: ':magicToken',
  METHOD: ':method',
  LINK: ':link',
  MERCHANT_TYPE: ':merchantType',
  TRANSACTION_ID: ':transactionId',
  ACCOUNT_ID: ':accountId',
  FROM_CURRENCY: ':fromCurrency',
  TO_CURRENCY: ':toCurrency',
  RECIPIENT_ID: ':recipientId',
  PAYER_ID: ':payerId',
  INVOICE_ID: ':invoiceId',
  CUSTOMER_ID: ':customerId',
  STATUS: ':status'
} as const)

export const CURRENCY_CODE = Object.freeze({
  EUR: 'EUR',
  USDT: 'USDT',
  USDT_TRC20: 'USDT.TRC20'
} as const)

export const MODAL_SIZE = Object.freeze({
  AUTO: 'auto',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  EXTRA_LARGE: 'extra-large',
  HORIZONTAL: 'horizontal',
  CENTERED: 'centered'
} as const)

export const COOKIE = Object.freeze({
  EXPIRATION_DAYS: 365,
  MAX_AGE_SECONDS: 31536000 // 365 days in seconds
} as const)

export const COOKIE_NAME = Object.freeze({
  CONSENT: 'cookie.consent'
} as const)

// noinspection SpellCheckingInspection
export const EXTERNAL_URL = Object.freeze({
  TERMS_AND_CONDITIONS: 'https://www.theguardianbank.com/terms-and-conditions',
  PRIVACY_POLICY: 'https://www.theguardianbank.com/privacy-policy',
  CALENDLY_BARAK_UYGUN: 'https://calendly.com/burak-uygun'
} as const)

export const QR_CODE = Object.freeze({
  SIZE: 256
} as const)

export const MASKED_SECRET_DISPLAY = '********'

export const SOCIAL_SHARE_URL = Object.freeze({
  WHATSAPP: 'https://wa.me/?text=',
  TELEGRAM: 'https://telegram.me/share/url?url=',
  LINKEDIN: 'https://www.linkedin.com/shareArticle?mini=true&url=',
  FACEBOOK: 'https://facebook.com/sharer/sharer.php?u='
} as const)

export const FISCAL_QUARTER = Object.freeze({
  Q1: 'Q1',
  Q2: 'Q2',
  Q3: 'Q3',
  Q4: 'Q4'
} as const)

export const FISCAL_MONTH = Object.freeze({
  M1: 'M1',
  M2: 'M2',
  M3: 'M3',
  M4: 'M4',
  M5: 'M5',
  M6: 'M6',
  M7: 'M7',
  M8: 'M8',
  M9: 'M9',
  M10: 'M10',
  M11: 'M11',
  M12: 'M12'
} as const)

export const ROUTE_ORIGIN = Object.freeze({
  TRANSACTIONS: 'transactions',
  ACCOUNTS: 'accounts',
  INVOICES: 'invoices',
  CUSTOMER_INVOICES: 'customer-invoices'
} as const)

export const SORT_DIRECTION = Object.freeze({
  ASC: 'asc',
  DESC: 'desc'
} as const)

export const DATE_FORMAT = 'dd MMM yyyy'

export const TOAST_CONFIG = Object.freeze({
  POSITION: 'top-right',
  CONTAINER_TOP: '10rem',
  Z_INDEX: '10010'
} as const)

export const TOOLTIP = Object.freeze({
  POSITION: {
    TOP: 'top',
    BOTTOM: 'bottom'
  },
  VARIANT: {
    DARK: 'dark',
    LIGHT: 'light'
  },
  EFFECT: {
    SOLID: 'solid',
    FLOAT: 'float'
  }
} as const)
